import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { MarketingRulesPage } from '@/components/MarketingRules/MarketingRulesPage'
import { rulesSearchSchema, withoutRulesSearchDefaults } from '@/components/MarketingRules/search'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/marketing/rules-v2/')({
  validateSearch: rulesSearchSchema,
  component: RulesV2Route,
})

function RulesV2Route() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <MarketingRulesPage
      search={search}
      onSearchChange={(next) =>
        void navigate({
          search: (current) => withoutRulesSearchDefaults({ ...current, ...next }),
          replace: true,
        })
      }
    />
  )
}
